import React, { Component } from "react";
import ReactEcharts from "echarts-for-react";
import { connect } from 'react-redux';
import axios from "axios";

const style = {
    flex: 1,
    height: "1200px",
    width: "100%"
};

class Pantalla5 extends Component {

    getOption = () => {
        const options = {
            toolbox: {
                show: true,
                itemSize: 30,
                feature: {
                    restore: { iconStyle: { borderWidth: 3 } },
                    saveAsImage: { iconStyle: { borderWidth: 3 } }
                }
            },
            tooltip: {
                trigger: 'axis',
                position: 'top'
            },
            grid: {
                left: 20,
                right: 10,
                bottom: 30,
                top: 120,
                containLabel: true
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    fontSize: 14,
                    fontWeight: 'bold'
                }
              },
              xAxis: {
                type: 'category',
                data: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul'],
                axisLabel: {
                    fontSize: 14,
                    fontWeight: 'bold'
                }
              },
              series: [
                {
                  name: 'Aceptados',
                  color: '#0F0',
                  type: 'line',
                  label: {
                    show: true
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  data: [20, 25, 30, 35, 50, 45, 22]
                },
              ]
        }
        return options;
    }
    
    render() {
        return (
            <div id="pantalla4" className="contenedorgrafica">
                <ReactEcharts
                    option={this.getOption()}
                    className="grafica"
                    style={style}
                    notMerge={false}
                    lazyUpdate={true}
                />
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        enviarmes: (mes) => dispatch({
            type: 'SET_MES', mes: mes
        })
    }
}
const mapStateToProps = state => ({
    loggedstate: state
})
export default connect(mapStateToProps, mapDispatchToProps)(Pantalla5);